import Link from "next/link";
import { Logo } from "@/components/logo";
import { BRAND } from "@/lib/brand";

interface MarketingFooterProps {
  variant?: "light" | "dark";
}

export function MarketingFooter({ variant = "light" }: MarketingFooterProps) {
  const isDark = variant === "dark";
  const currentYear = new Date().getFullYear();

  const links = [
    { href: "/auth", label: "Sign in" },
    { href: "/pricing", label: "Pricing" },
    { href: "/changelog", label: "Changelog" },
    { href: "/security", label: "Security" },
    { href: "/status", label: "Status" },
    { href: "/privacy", label: "Privacy" },
    { href: "/terms", label: "Terms" },
  ];

  return (
    <footer
      className={`border-t py-12 px-6 ${
        isDark
          ? "bg-gray-900 border-gray-800"
          : "bg-white border-gray-200"
      }`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link href="/" className="flex items-center gap-2.5">
            <Logo
              size="lg"
              className={isDark ? "text-white" : "text-gray-900"}
            />
            <span
              className={`text-xl font-bold ${
                isDark ? "text-white" : "text-gray-900"
              }`}
            >
              {BRAND.name}
            </span>
          </Link>
          <div className="flex flex-wrap items-center gap-6 md:gap-8">
            {links.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={`text-sm transition-colors ${
                  isDark
                    ? "text-gray-400 hover:text-white"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <p
              className={`text-sm ${
                isDark ? "text-gray-500" : "text-gray-500"
              }`}
            >
              © {currentYear} {BRAND.name}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
